import { render, staticRenderFns } from "./commission-page.vue?vue&type=template&id=f53a84b8&scoped=true&"
import script from "./commission-page.vue?vue&type=script&lang=js&"
export * from "./commission-page.vue?vue&type=script&lang=js&"
import style0 from "./commission-page.vue?vue&type=style&index=0&id=f53a84b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53a84b8",
  null
  
)

export default component.exports